import React from "react";
import PropTypes from "prop-types";

import LogoSrc from "./ps_vs_app.png";

const propTypes = {};
const defaultProps = {};

function Logo({}) {
  return <img src={LogoSrc} width="300px" height="83px" />;
}

Logo.propTypes = propTypes;
Logo.defaultProps = defaultProps;

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo/index.js